import type { TypedDocumentNode } from '@apollo/client';
import { gql, useLazyQuery } from '@apollo/client';

import type {
  TransactionStatusQuery,
  TransactionStatusQueryVariables,
} from './__generated__/useFetchTransactionStatus.graphql.ts';

const TRANSACTION_STATUS_QUERY = gql`
  query TransactionStatusQuery($transactionId: String!) {
    mangopay {
      id
      remoteTransactionStatus(transactionId: $transactionId) {
        status
        message
      }
    }
  }
` as TypedDocumentNode<TransactionStatusQuery, TransactionStatusQueryVariables>;

export const useFetchTransactionStatus = () => {
  return useLazyQuery(TRANSACTION_STATUS_QUERY);
};
